export type FileInfo = API.File;

export type BuildArtifact = API.BuildArtifact & { link: string | null };
export enum FileStatus {
    Pending = 0,
    Uploaded = 1,
}

export interface FileTableItem extends FileInfo {
    rolloutTag?: API.Tag | null;
    hasTags?: number | API.Tag | null;
    groupName?: string;
    uploader?: string;
    isUploading?: boolean;
    status: FileStatus;
    version?: string;
    sha256?: string;
    codename?: string;
    visibility?: string;
    removableTags?: API.Tag[];
}

export enum FileContentType {
    Json = "application/json",
    ImageJpeg = "image/jpeg",
    ImagePng = "image/png",
    ImageGif = "image/gif",
    TextPlain = "text/plain",
    TextCsv = "text/csv",
    Apk = "application/vnd.android.package-archive",
    ApkV2 = "application/x-apk",
    Zip = "application/zip",
    ZipCompressed = "application/zip-compressed",
    ZipCompressedV2 = "application/x-zip-compressed",
    ZipMultipart = "multipart/x-zip",
    Executable = "application/octet-stream",
}

export enum SourceType {
    User = 0,
    Device = 1,
    Microservice = 2,
}
